import React, { useState, useEffect, useCallback } from 'react';
import './../../App.css';
import './Employees.css';
import {CreateButton, CreateSearchBarWithPlaceHolder} from './../CommonObjects';
import axios from 'axios';
import {CreateTable, CreateTableForEmployeeSelect} from './../ManageTable';
import {token, domain} from './../Security';
import loadingSpinner from './../../assets/loading.gif';
// icon
import SearchIcon from '@mui/icons-material/Search';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';

import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

function PRCLicense({user, isHideSideMenu}) {
    var header = [
        "EmployeeId",
        "Employee",
        "Registration No.",
        "Registration Date",
        "Validation Date",
        "Remarks",
        "",
    ]
    var accessor = [
        "employeePersonalInformationEmployeeId",
        "employeePersonalInformationFullName",
        "registrationNumber",
        "registrationDate",
        "validationDate",
        "remarks",
        "manage"
    ]

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [loadingRequest, setLoadingRequest] = useState(false);
    const [data, setData] = useState([]);

     // Retrieve
    const [filterData, setFilterData] = useState([]);

    const [employee, setEmployee] = useState(null);
    const [registrationDate, setRegistrationDate] = useState(null);
    const [registrationNumber, setRegistrationNumber] = useState(null);
    const [remarksPRC, setRemarksPRC] = useState(null);
    const [validationDate, setValidationDate] = useState(null);
    const [selectedData, setSelectedData] = useState(null);

    const resetLocalVariables = () => {
        setEmployee(null);
        setRegistrationDate(null);
        setRegistrationNumber(null);
        setRemarksPRC(null);
        setValidationDate(null);
        setSelectedData(null);
    }
    
    // Add
    const [showAddForm, setShowAddForm] = useState(false);
    const openAddForm = () => {
        setShowAddForm(true)
    }
    const closeAddForm = () => {
        setShowAddForm(false)
        resetLocalVariables()
    }
    //Update
    const [showEditForm, setShowEditForm] = useState(false);
    const openEditForm = () => {
        setShowEditForm(true)
    }
    const closeEditForm = () => {
        setShowEditForm(false)
        resetLocalVariables()
    }

    //Request Messages -start
    const [showRequestMessage, setShowRequestMessage] = useState(false);
    const [requestMessage, setRequestMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState("");
    useEffect(() => {
        if (showRequestMessage) {
            const timeoutId = setTimeout(() => {
                setShowRequestMessage(false);
            }, 5000);

            return () => clearTimeout(timeoutId);
        }
        
    }, [showRequestMessage]);
    function GenerateMessage({form, message, isSuccess}){
        return (
            <>
                <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
                    {form && (
                    <div className="modal toggleMessage" style={{backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5"}}>
                        <div className='column'>
                            {isSuccess ?
                                <div className='request_title row' style={{fontWeight:"bold", color:"green", alignItems:"center"}}>
                                    <CheckCircleIcon/>
                                    <span >{"SUCCESS MESSAGE"}</span>
                                </div>
                                :
                                <div className='request_title row' style={{fontWeight:"bold", color:"#DD5746", alignItems:"center"}}>
                                    <ErrorIcon/>
                                    <span>{"ERROR MESSAGE"}</span>
                                </div>
                            }
                            <span style={{textAlign:"center", padding:"10px 0", color: isSuccess? "green" : "#DD5746"}}>{message}</span>
                        </div>
                    </div>
                )}
                </div>
            </>
        );
    }
    //Request Messages -end
    
    const apiUrl =  domain + "/api/EmployeePRCLicense";

    const fetchData = useCallback(async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${apiUrl}` , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            setData(response.data); // Set the response data to the state
            setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [apiUrl]);

    useEffect(() => {
        fetchData();
        
    }, [fetchData]);

    const handleFilter = (value) => {
        const lowercaseValue = value.toLowerCase();
        setCurrentPage(1);
        var res = filterData.filter((f) =>
                f.employeePersonalInformationEmployeeId?.toLowerCase()?.startsWith(lowercaseValue) ||
                f.employeePersonalInformationFullName?.toLowerCase()?.includes(lowercaseValue)
                );

        setData(res);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        const _data = {
            employeePersonalInformationId: employee?.id,
            isLicensed: true,
            registrationNumber: registrationNumber,
            remarks: remarksPRC,
            registrationDate: registrationDate,
            validationDate: validationDate,
        };

        try {
            setLoadingRequest(true);
            await axios.post(apiUrl, _data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            
            await fetchData(); // Assuming fetchData() fetches the updated data for the table
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem updating data:', error);

            setShowRequestMessage(true);
            setIsSuccess(false);

            const errorMessage = error?.response?.request?.responseText;

            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };
    const handleUpdate = async (event) => {
        event.preventDefault();

        const _data = {
            employeePersonalInformationId: employee?.id,
            isLicensed: true,
            registrationNumber: registrationNumber,
            remarks: remarksPRC,
            registrationDate: registrationDate,
            validationDate: validationDate,
        };

        try {
            setLoadingRequest(true);
            await axios.put(apiUrl + `/${selectedData?.id}`, _data, {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            });
            await fetchData(); // Assuming fetchData() fetches the updated data for the table

            console.log('Data updated successfully');
            setShowRequestMessage(true);
            setIsSuccess(true);
        } catch (error) {
            console.error('There was a problem updating data:', error);

            setShowRequestMessage(true);
            setIsSuccess(false);

            const errorMessage = error?.response?.request?.responseText;

            setRequestMessage(errorMessage);
        } finally {
            setLoadingRequest(false);
        }
    };

    const fetchDataById = useCallback(async (_data) => {
        try {
            const response = await axios.get(`${apiUrl}/${_data?.id}` , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
        }})
            return (response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
            return null
        }
    }, [apiUrl]);

    const addHandleClick = () => {
        openAddForm();
    };
    const editHandleClick = async (_data) => {
        setLoadingRequest(true);

        const fetchedData = await fetchDataById(_data)
        setSelectedData(fetchedData);

        setEmployee(fetchedData.employee);
        setRegistrationNumber(fetchedData.registrationNumber);
        setRemarksPRC(fetchedData.remarks);
        setRegistrationDate(fetchedData.registrationDate);
        setValidationDate(fetchedData.validationDate);

        openEditForm()
        setLoadingRequest(false);
    };

    const exportHandleClick = async () => {
        const header = [
            "EmployeeId",
            "Employee",
            "Registration No.",
            "Registration Date",
            "Validation Date",
            "Remarks",
        ];

        const accessor = [
            "employeePersonalInformationEmployeeId",
            "employeePersonalInformationFullName",
            "registrationNumber",
            "registrationDate",
            "validationDate",
            "remarksPRC",
        ];

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Employee PRC License");

        // Add header
        worksheet.addRow(header);

        // Add data
        data.forEach((item) => {
            worksheet.addRow(
                accessor.map((key) => item[key] ?? "")
            );
        });

        // Header styling
        const headerRow = worksheet.getRow(1);

        headerRow.eachCell((cell) => {
            cell.font = {
                bold: true,
                color: { argb: "FFFFFF" },
            };

            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "4FAB8E" },
            };

            cell.alignment = {
                horizontal: "center",
                vertical: "middle",
            };

            cell.border = {
                top: { style: "thin" },
                bottom: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" },
            };
        });

        // Format dates
        worksheet.eachRow((row, rowNumber) => {
            if (rowNumber === 1) return;

            // Registration Date
            if (row.getCell(4).value) {
                row.getCell(4).value = new Date(row.getCell(4).value);
                row.getCell(4).numFmt = "mm/dd/yyyy";
            }

            // Validation Date
            if (row.getCell(5).value) {
                row.getCell(5).value = new Date(row.getCell(5).value);
                row.getCell(5).numFmt = "mm/dd/yyyy";
            }
        });

        // Auto width
        worksheet.columns.forEach((column) => {
            let maxLength = 0;

            column.eachCell({ includeEmpty: true }, (cell) => {
                const value = cell.value ? cell.value.toString() : "";
                maxLength = Math.max(maxLength, value.length);
            });

            column.width = Math.min(maxLength + 2, 40);
        });

        // Freeze header
        worksheet.views = [
            {
                state: "frozen",
                ySplit: 1,
            },
        ];

        // Generate Excel
        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(
            new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }),
            "Employee_PRC_License.xlsx"
        );
    };

    const [showImportModal, setShowImportModal] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [isDragging, setIsDragging] = useState(false);

    const downloadTemplate = async () => {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Employee PRC License");

        const header = [
            "EmployeeId",
            "Employee",
            "Registration No.",
            "Registration Date",
            "Validation Date",
        ];

        worksheet.addRow(header);

        // Header styling
        const headerRow = worksheet.getRow(1);

        headerRow.eachCell((cell) => {
            cell.font = {
                bold: true,
                color: { argb: "FFFFFF" },
            };

            cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: { argb: "4FAB8E" },
            };

            cell.alignment = {
                horizontal: "center",
                vertical: "middle",
            };
        });

        worksheet.columns = [
            { width: 20 },
            { width: 30 },
            { width: 20 },
            { width: 20 },
            { width: 20 },
        ];

        // Registration Date - Column D
        for (let row = 2; row <= 1000; row++) {
            worksheet.getCell(`D${row}`).dataValidation = {
                type: "date",
                operator: "between",
                formulae: [
                    new Date(1900, 0, 1),
                    new Date(9999, 11, 31),
                ],
                allowBlank: true,
                showErrorMessage: true,
                errorStyle: "stop",
                errorTitle: "Invalid Date",
                error: "Please enter a valid date.",
            };

            worksheet.getCell(`D${row}`).numFmt = "mm/dd/yyyy";

            // Validation Date - Column E
            worksheet.getCell(`E${row}`).dataValidation = {
                type: "date",
                operator: "between",
                formulae: [
                    new Date(1900, 0, 1),
                    new Date(9999, 11, 31),
                ],
                allowBlank: true,
                showErrorMessage: true,
                errorStyle: "stop",
                errorTitle: "Invalid Date",
                error: "Please enter a valid date.",
            };

            worksheet.getCell(`E${row}`).numFmt = "mm/dd/yyyy";
        }

        const buffer = await workbook.xlsx.writeBuffer();

        saveAs(
            new Blob([buffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            }),
            "Employee_PRC_License_Template.xlsx"
        );
    };
    
    const importHandleClick = () => {
        setSelectedFile(null);
        setShowImportModal(true);
    };

    const handleImport = async () => {
        if (!selectedFile) {
            alert("Please select an Excel file.");
            return;
        }

        try {
            const workbook = new ExcelJS.Workbook();

            const buffer = await selectedFile.arrayBuffer();

            await workbook.xlsx.load(buffer);

            const worksheet = workbook.getWorksheet("Employee PRC License");

            if (!worksheet) {
                alert("Invalid template. Please use the Employee PRC License template.");
                return;
            }

            const dtos = [];

            // Convert Excel date to yyyy-MM-dd
            const formatDate = (value) => {
                if (!value) {
                    return null;
                }

                let date;

                // ExcelJS date value
                if (value instanceof Date) {
                    date = value;
                }

                // Excel serial date
                else if (typeof value === "number") {
                    const excelEpoch = new Date(Date.UTC(1899, 11, 30));

                    date = new Date(
                        excelEpoch.getTime() + value * 86400000
                    );
                }

                // String date
                else if (typeof value === "string") {

                    // If already yyyy-MM-dd
                    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
                        return value;
                    }

                    // If MM/DD/YYYY
                    const parts = value.split("/");

                    if (parts.length === 3) {
                        const month = parts[0].padStart(2, "0");
                        const day = parts[1].padStart(2, "0");
                        const year = parts[2];

                        return `${year}-${month}-${day}`;
                    }

                    return null;
                }

                else {
                    return null;
                }

                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");

                return `${year}-${month}-${day}`;
            };

            worksheet.eachRow((row, rowNumber) => {

                // Skip header
                if (rowNumber === 1) return;

                const employeeId = row.getCell(1).value;
                const employee = row.getCell(2).value;
                const registrationNumber = row.getCell(3).value;
                const registrationDate = row.getCell(4).value;
                const validationDate = row.getCell(5).value;
                const remarksPRC = row.getCell(6).value;

                // Skip completely empty rows
                if (
                    !employeeId &&
                    !employee &&
                    !registrationNumber &&
                    !registrationDate &&
                    !validationDate
                ) {
                    return;
                }

                // EmployeeId is required
                if (!employeeId) {
                    return;
                }

                dtos.push({
                    EmployeeId: employeeId.toString().trim(),

                    IsLicensed: true,

                    RegistrationNumber: registrationNumber
                        ? registrationNumber.toString().trim()
                        : null,

                    RegistrationDate: formatDate(registrationDate),

                    ValidationDate: formatDate(validationDate),
                    Remarks: remarksPRC?.toString(),
                });
            });

            if (dtos.length === 0) {
                alert("No valid data found in the Excel file.");
                return;
            }

            console.log("Import data:", dtos);

            await axios.post(
                `${domain}/api/EmployeePRCLicense/upload`,
                dtos
            );

            await fetchData();

            setShowRequestMessage(true);
            setIsSuccess(true);
            setRequestMessage("Upload successful");

            setSelectedFile(null);
            setShowImportModal(false);

        } catch (error) {
            console.error("There was a problem updating data:", error);

            setShowRequestMessage(true);
            setIsSuccess(false);

            const errorMessage =
                error?.response?.data?.message ||
                error?.response?.data?.errors?.["$[0].RegistrationDate"]?.[0] ||
                error?.response?.data ||
                error?.message ||
                "An error occurred while importing.";

            setRequestMessage(
                typeof errorMessage === "string"
                    ? errorMessage
                    : JSON.stringify(errorMessage)
            );
        }
    };
    
    return (
        <div>
            <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
                <div className="LeftSpace"></div>
                <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
                    <div className="EmployeesTabInfo">
                        <div className="employeesTab-header">
                            <div className='sub-title row'>
                                <span style={{padding:"0 5px 0 0", color:"#b0b0b0"}}>{"Personnel >"} </span>
                                <span style={{borderBottom:"1px solid black"}}>{"PRC License"}</span>
                            </div>
                            <h3>PRC License</h3>
                        </div>
                        <div className="employeesTab-body">
                            <div className="body-top row">
                                <div className="body-top-search">
                                    {CreateSearchBarWithPlaceHolder("", 
                                                                    "mainte-search row", 
                                                                    "mainte-search-icon", 
                                                                    "mainte-search-input", 
                                                                    (e)=>handleFilter(e.target.value), 
                                                                    "Search ...", 
                                                                    SearchIcon)} 
                                </div>
                                <div className="body-top-btn row"  style={{justifyContent: "end"}}>
                                    <button className='border border-green-800 bg-green-500 hover:bg-green-600 text-white cursor-pointer flex flex-row items-center
                                        rounded-sm py-[7px]'
                                        onClick={exportHandleClick}
                                    >
                                        <FileDownloadIcon/>
                                        EXPORT
                                    </button>
                                    <button className='border border-blue-800 bg-blue-500 hover:bg-blue-600 text-white cursor-pointer flex flex-row items-center
                                        rounded-sm py-[7px]'
                                        onClick={importHandleClick}
                                    >
                                        <FileUploadIcon/>
                                        IMPORT
                                    </button>
                                    {CreateButton("", "add row", addHandleClick, "ADD", NoteAddIcon)}
                                </div>
                            </div>
                            <div className="employeesTab-table container">
                                <CreateTable
                                    dataList={data || []}
                                    dataHeader={header}
                                    dataAccessor={accessor}
                                    editHandleClick={editHandleClick}
                                    currentPage={currentPage}
                                    setCurrentPage={setCurrentPage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <AddForm  isOpen={showAddForm} 
                    onClose={closeAddForm}
                    employee={employee} setEmployee={setEmployee}
                    registrationNumber={registrationNumber} setRegistrationNumber={setRegistrationNumber}
                    remarksPRC={remarksPRC} setRemarksPRC={setRemarksPRC}
                    registrationDate={registrationDate} setRegistrationDate={setRegistrationDate}
                    validationDate={validationDate} setValidationDate={setValidationDate}
                    handleSubmit={handleSubmit}
            >
            </AddForm>
            <EditForm  isOpen={showEditForm} 
                    onClose={closeEditForm}
                    employee={employee} setEmployee={setEmployee}
                    registrationNumber={registrationNumber} setRegistrationNumber={setRegistrationNumber}
                    remarksPRC={remarksPRC} setRemarksPRC={setRemarksPRC}
                    registrationDate={registrationDate} setRegistrationDate={setRegistrationDate}
                    validationDate={validationDate} setValidationDate={setValidationDate}
                    handleSubmit={handleUpdate}
            >
            </EditForm>
            {showImportModal && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">

                    <div className="bg-white rounded-md shadow-xl w-[800px] max-w-[95%]">

                        {/* Header */}
                        <div className="flex items-center justify-between px-5 py-4 border-b">
                            <h2 className="text-lg font-semibold text-gray-700">
                                Import Employee PRC License
                            </h2>

                            <button
                                type="button"
                                onClick={() => setShowImportModal(false)}
                                className="text-gray-400 hover:text-gray-600 text-xl cursor-pointer"
                            >
                                ×
                            </button>
                        </div>

                        {/* Body */}
                        <div className="flex flex-row p-5 gap-5">

                            {/* LEFT - Download Template */}
                            <div className="w-1/2 border rounded-md p-5 flex flex-col items-center justify-center">

                                <div className="text-green-600 text-4xl mb-3">
                                    <FileDownloadIcon fontSize="large" />
                                </div>

                                <h3 className="font-semibold text-gray-700 mb-2">
                                    Download Template
                                </h3>

                                <p className="text-sm text-gray-500 text-center mb-5">
                                    Download the Excel template and fill in the
                                    employee registration information.
                                </p>

                                <button
                                    type="button"
                                    onClick={downloadTemplate}
                                    className="px-4 py-2 bg-green-500 hover:bg-green-600
                                            text-white rounded-sm text-sm cursor-pointer
                                            border border-green-800"
                                >
                                    DOWNLOAD TEMPLATE
                                </button>

                            </div>


                            {/* RIGHT - Upload */}
                            <div className="w-1/2">

                                <div
                                    className={`h-full min-h-[250px] border-2 border-dashed
                                        rounded-md flex flex-col items-center justify-center
                                        cursor-pointer transition
                                        ${
                                            isDragging
                                                ? "border-green-500 bg-green-50"
                                                : "border-gray-300 hover:border-green-500"
                                        }`}
                                    onDragOver={(e) => {
                                        e.preventDefault();
                                        setIsDragging(true);
                                    }}
                                    onDragLeave={(e) => {
                                        e.preventDefault();
                                        setIsDragging(false);
                                    }}
                                    onDrop={(e) => {
                                        e.preventDefault();
                                        setIsDragging(false);

                                        const file = e.dataTransfer.files?.[0];

                                        if (file) {
                                            setSelectedFile(file);
                                        }
                                    }}
                                    onClick={() => {
                                        document.getElementById("importFileInput").click();
                                    }}
                                >

                                    <input
                                        id="importFileInput"
                                        type="file"
                                        accept=".xlsx,.xls"
                                        className="hidden"
                                        onChange={(e) => {
                                            const file = e.target.files?.[0];

                                            if (file) {
                                                setSelectedFile(file);
                                            }
                                        }}
                                    />

                                    <div className="text-gray-400 text-5xl mb-3">
                                        <FileUploadIcon fontSize="large" />
                                    </div>

                                    {selectedFile ? (
                                        <>
                                            <p className="font-medium text-green-600">
                                                {selectedFile.name}
                                            </p>

                                            <p className="text-xs text-gray-500 mt-1">
                                                {(selectedFile.size / 1024).toFixed(2)} KB
                                            </p>
                                        </>
                                    ) : (
                                        <>
                                            <p className="font-medium text-gray-600">
                                                Drag & Drop your Excel file here
                                            </p>

                                            <p className="text-sm text-gray-400 my-2">
                                                or
                                            </p>

                                            <button
                                                type="button"
                                                className="px-4 py-2 border border-gray-500
                                                        bg-white
                                                        text-gray-500 hover:bg-gray-50
                                                        rounded-sm text-sm cursor-pointer"
                                            >
                                                SELECT FILE
                                            </button>

                                            <p className="text-xs text-gray-400 mt-3">
                                                Supported files: .xlsx, .xls
                                            </p>
                                        </>
                                    )}

                                </div>

                            </div>

                        </div>

                        {/* Footer */}
                        <div className="flex justify-end gap-2 px-5 py-4 border-t">

                            <button
                                type="button"
                                onClick={() => setShowImportModal(false)}
                                className="px-4 py-2 border-none 
                                        text-white bg-red-500 hover:bg-red-600
                                        rounded-sm text-sm cursor-pointer"
                            >
                                CANCEL
                            </button>

                            <button
                                type="button"
                                disabled={!selectedFile}
                                onClick={handleImport}
                                className={`px-4 py-2 rounded-sm text-sm text-white
                                    ${
                                        selectedFile
                                            ? "bg-green-500 hover:bg-green-600 cursor-pointer"
                                            : "bg-gray-300 cursor-not-allowed"
                                    }`}
                            >
                                IMPORT
                            </button>

                        </div>

                    </div>
                </div>
            )}
            <GenerateMessage form={showRequestMessage}
                    message={isSuccess ? "Request Success!" : requestMessage}
                    isSuccess={isSuccess}
            > 
            </GenerateMessage>
            {loadingRequest || loading ? (
            <div
                style={{
                position: "fixed",
                top: "0",
                left: "0",
                width: "100vw",
                height: "100vh",
                zIndex: "2000",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                backgroundColor: "#ffffff59",
                }}
            >
                <img src={loadingSpinner} alt="Loading..." />
            </div>
            ) : (
                <></>
                )
            }
        </div>
    )
}

function AddForm({
    isOpen, 
    onClose,
    employee, setEmployee,
    registrationNumber, setRegistrationNumber,
    remarksPRC, setRemarksPRC,
    registrationDate, setRegistrationDate,
    validationDate, setValidationDate,
    handleSubmit}) 
{
    const [errorState, setErrorState] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false)
    const openEmployeeForm = () => {
        setShowEmployeeForm(true)
    }
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false)
    }

    const submit = (e) =>{
        if(!employee
            || !registrationNumber
            || !registrationDate
            || !validationDate
        ){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
        handleClose();
    };

    const handleClose = () => {
        onClose();
        setErrorState(false);
        closeEmployeeForm();
    };
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Add License</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employee ? (employee?.fullName) : "Select Employee"}
                                    />
                                    <button className="select row"
                                            onClick={openEmployeeForm}
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employee && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Registration Number</div>
                            <div className="info-item-input">
                                <input
                                placeholder="XXXXX-XXXXX-XXXXX"
                                value={registrationNumber}
                                onChange={(e) => setRegistrationNumber(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !registrationNumber && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Registration Date</div>
                            <div className="info-item-input">
                                <DateInput data={registrationDate} setData={setRegistrationDate}/>
                            </div>
                            <span style={{
                                        visibility: !registrationDate && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Validation Date</div>
                            <div className="info-item-input">
                                <DateInput data={validationDate} setData={setValidationDate}/>
                            </div>
                            <span style={{
                                        visibility: !validationDate && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Remarks</div>
                            <div className="info-item-input">
                                <textarea id="overtime-tamper"
                                        style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={remarksPRC}
                                        onChange={(e) => setRemarksPRC(e.target.value)}
                                />
                            </div>
                            <span style={{
                                    visibility: "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                SAVE
                        </button>
                    </div>
                </div>
            )}
            </div>

            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    data={employee}
                    setData={setEmployee}
            />
        </>
    );
}
function EditForm({
    isOpen, 
    onClose, 
    employee, setEmployee,
    registrationNumber, setRegistrationNumber,
    remarksPRC, setRemarksPRC,
    registrationDate, setRegistrationDate,
    validationDate, setValidationDate,
    handleSubmit})
{
    const [errorState, setErrorState] = useState(false);
    const [showEmployeeForm, setShowEmployeeForm] = useState(false)
    const openEmployeeForm = () => {
        setShowEmployeeForm(true)
    }
    const closeEmployeeForm = () => {
        setShowEmployeeForm(false)
    }

    const submit = (e) =>{
        if(!employee
            || !registrationNumber
            || !registrationDate
            || !validationDate
        ){
            setErrorState(true);
            return;
        }
        handleSubmit(e);
        setErrorState(false);
        handleClose();
    };
    const handleClose = () => {
        onClose();
        setErrorState(false);
        closeEmployeeForm();
    };

    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Update License</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="popUp-body">
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Employee</div>
                            <div className="info-item-input">
                                <div className="info-item-holder employee-select row" style={{flexDirection:"row", justifyContent:"normal"}}>
                                    <input
                                        readOnly
                                        className='employeeInput-select'
                                        placeholder="Employee"
                                        value={employee ? (employee?.fullName) : "Select Employee"}
                                    />
                                    <button className="select row hidden"
                                            onClick={openEmployeeForm}
                                            disabled
                                    ><SearchIcon/></button>
                                </div>
                                <span style={{
                                        visibility: !employee && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                                </span>
                            </div>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Registration Number</div>
                            <div className="info-item-input">
                                <input
                                placeholder="XXXXX-XXXXX-XXXXX"
                                value={registrationNumber}
                                onChange={(e) => setRegistrationNumber(e.target.value)}
                                />
                            </div>
                            <span style={{
                                        visibility: !registrationNumber && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Registration Date</div>
                            <div className="info-item-input">
                                <DateInput data={registrationDate} setData={setRegistrationDate}/>
                            </div>
                            <span style={{
                                        visibility: !registrationDate && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Validation Date</div>
                            <div className="info-item-input">
                                <DateInput data={validationDate} setData={setValidationDate}/>
                            </div>
                            <span style={{
                                        visibility: !validationDate && errorState ? "visible" : "hidden",
                                        color:"#ff6565", 
                                        fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                        <div className="popUp-item info-item column">
                            <div className="info-item-label">Remarks</div>
                            <div className="info-item-input">
                                <textarea id="overtime-tamper"
                                        style={{width:"95%",minHeight:"100px", borderRadius:"3px", border:"1px solid #80808080",color: "rgb(104, 104, 104)"}}
                                        value={remarksPRC}
                                        onChange={(e) => setRemarksPRC(e.target.value)}
                                />
                            </div>
                            <span style={{
                                    visibility: "hidden",
                                    color:"#ff6565", 
                                    fontSize:"12px"}}>Please fill up this field
                            </span>
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"20px 40px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={(e)=>submit(e)}>
                                UPDATE
                        </button>
                    </div>
                </div>
            )}
            </div>

            <EmployeeSelectForm  isOpen={showEmployeeForm} 
                    onClose={closeEmployeeForm}
                    data={employee}
                    setData={setEmployee}
            />
        </>
    );
}
function EmployeeSelectForm({
    isOpen, 
    onClose,
    data, setData,
}) 
{
    var header = [
        "Id",
        "Name",
    ]
    var accessor = [
        "employeeId",
        "fullName"
    ]

    const handleClose = () => {
        onClose();
        fetchData();
    };
    const handleProceed = () => {
        onClose();
        setData(selectedEmployee);
        fetchData();
    };

    const [currentPage, setCurrentPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [employees, setEmployees] = useState([]);
    const [selectedEmployee, setSelectedEmployee] = useState([]);
    const [filterData, setFilterData] = useState([]);

    const fetchData = useCallback( async () => {
        const apiUrl =  domain + "/api/Employee/basic-info/all/active";

        try {
            setLoading(true);
            const response = await axios.get(apiUrl , {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json' // You can include other headers if needed
            }})
                setEmployees(response.data); // Set the response data to the state
                setFilterData(response.data); // Set the response data to the state
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false); // Set loading state to false after data fetching is complete
        }
    }, [])

    const handleFilter = (value) => {
        setCurrentPage(1);
        const lowercaseValue = value.toLowerCase();
        var res = filterData.filter((f) =>
                f.fullName?.toLowerCase()?.includes(lowercaseValue) ||
                f.employeeId?.toLowerCase()?.startsWith(lowercaseValue)
                );

        setEmployees(res);
    };

    useEffect(() => {
        fetchData();
    }, [fetchData]);
    
    return (
        <>
            <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
                {isOpen && (
                <div className="modal">
                    <div className="popUp-header row">
                        <div className="popUp-title">
                            <h3 style={{ color: "#668fca" }}>Select Employee</h3>
                        </div>
                        <div className="popUp-close">
                            <CloseIcon onClick={()=>handleClose()} />
                        </div>
                    </div>
                    <div className="transaction-body">
                            <div className="transaction-body-top row">
                                {CreateSearchBarWithPlaceHolder("", 
                                                                "transaction-search row", 
                                                                "transaction-search-icon", 
                                                                "transaction-search-input", 
                                                                (e)=>handleFilter(e.target.value), 
                                                                "Search ...",
                                                                SearchIcon)}
                            </div>
                        </div>
                    <div className="popUp-body">
                        <div className="select-employee-table">
                            <CreateTableForEmployeeSelect
                                dataList={employees}
                                dataHeader={header}
                                dataAccessor={accessor}
                                setSelectedEmployee={setSelectedEmployee}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                            />
                            {employees.length > 0 ? (
                                    <div></div>
                            )
                            :
                            (
                                <div>
                                {loading ? (
                                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '10vh' }}>
                                        <img src={loadingSpinner} alt="Loading..." />
                                    </div>
                                ) : (
                                        <div> {/*<p>No records to display</p>*/}</div>
                                    )
                                }
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="buttons row" style={{justifyContent:"end", padding:"50px 20px 0 20px"}}>
                        <button id="add-family" 
                            className="save row"
                            onClick={handleProceed}>
                                PROCEED
                        </button>
                    </div>
                </div>
            )}
            </div>
        </>
    );
}
function DateInput({
    data, setData
}) {
    const [isSelected, setIsSelected] = useState(false);

    const handleDateTimeChange = (event) => {
        setData(event.target.value);
        setIsSelected(true);
    };

    useEffect(() => {
        setIsSelected(data);
    }, [data]);

    let formattedDate = "";

    if(data){
        formattedDate = data.split('T')[0];
    }

    return (
        <div>
            <input
            type="date"
            id={"datetime-"}
            name="datetime"
            value={formattedDate}
            onChange={handleDateTimeChange}
            style={{width:"90%",
                height:"30px", 
                borderRadius:"3px", 
                border:"1px solid #80808080",
                color: isSelected ? "rgb(104, 104, 104)" : "rgba(0, 0, 0, 0.356)",
                fontFamily: "'Trebuchet MS', 'Lucida Sans Unicode', 'Lucida Grande', 'Lucida Sans', Arial, sans-serif"
            }}
            />
        </div>
    );
}

export default PRCLicense
